import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=2fa1771b&scoped=true"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"
import style0 from "./Consent.vue?vue&type=style&index=0&id=2fa1771b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1771b",
  null
  
)

export default component.exports